const header = document.querySelector('.mm-header');
const logoContainer = header.querySelector('.mm-logo-container');
const logoScroll = logoContainer.querySelector('.mm-logo-scroll');
const logo = logoContainer.querySelector('.mm-logo-black');

window.addEventListener('scroll', () => {
	if (window.scrollY > 200) {
		if (header.classList.contains('mm-header-template-index')) {
			header.classList.remove('mm-header-transparent');
			if (logoScroll) {
				header.addEventListener('mouseenter', () => {
					logoHide();
				});
				header.addEventListener('mouseleave', () => {
					logoScrollHide();
				});
			}
		}
		if (logoScroll) {
			logoHide();
		}
	} else {
		if (header.classList.contains('mm-header-template-index')) {
			header.classList.add('mm-header-transparent');
			if (logoScroll) {
				header.removeEventListener('mouseenter', () => {
					logoHide();
				});
				header.removeEventListener('mouseleave', () => {
					logoScrollHide();
				});
			}
		}
		if (logoScroll) {
			logoScrollHide();
		}
	}
});

if (logoScroll) {
	header.addEventListener('mouseenter', () => {
		logoHide();
	});
	header.addEventListener('mouseleave', () => {
		logoScrollHide();
	});
}

function logoHide() {
	logoScroll.classList.remove('hidden');
	logo.classList.add('hidden');
}
function logoScrollHide() {
	logoScroll.classList.add('hidden');
	logo.classList.remove('hidden');
}

/* Animation megamenu */
document.addEventListener('DOMContentLoaded', () => {
	const headerLinks = header.querySelectorAll('[data-megamenulink]');

	/**
	 * Met à jour la hauteur du mega-menu pour correspondre à son contenu
	 * @param {HTMLElement} megaMenu - L'élément mega-menu
	 */
	function updateMegaMenuHeight(megaMenu) {
		if (!megaMenu) return;

		let maxHeight = 0;
		megaMenu.querySelectorAll(':scope > *').forEach((child) => {
			maxHeight = Math.max(maxHeight, child.offsetHeight);
		});

		megaMenu.style.height = `${maxHeight}px`;
	}

	/**
	 * Charge les images lazy du mega-menu en convertissant data-src en src
	 * @param {HTMLElement} megaMenu - L'élément mega-menu
	 */
	function loadMegaMenuImages(megaMenu) {
		if (!megaMenu) return;

		const images = megaMenu.querySelectorAll('img[data-src]');
		images.forEach((img) => {
			if (img.dataset.src) {
				img.src = img.dataset.src;
				delete img.dataset.src;
			}
			if (img.dataset.srcset) {
				img.srcset = img.dataset.srcset;
				delete img.dataset.srcset;
			}
		});
	}

	headerLinks.forEach((link) => {
		const megaMenu = link.nextElementSibling;

		if (!megaMenu) return;

		let imagesLoaded = false;

		// Met à jour la hauteur et charge les images lors du survol du lien
		link.addEventListener('mouseenter', () => {
			if (!imagesLoaded) {
				loadMegaMenuImages(megaMenu);
				imagesLoaded = true;
			}
			updateMegaMenuHeight(megaMenu);
		});

		// Met à jour la hauteur lors du survol du méga-menu lui-même
		// megaMenu.addEventListener("mouseenter", () => {
		// 	updateMegaMenuHeight(megaMenu);
		// });

		// Réinitialise la hauteur à 250px quand le hover s'arrête
		// megaMenu.addEventListener("mouseleave", () => {
		// 	megaMenu.style.height = '250px';
		// });
	});
});

function initMobileSplide() {
	let id = '.mm-splide-menu-mobile';
	let splideElem = document.querySelector(id);

	if (splideElem && !splideElem.classList.contains('splide-initialized')) {
		let bar = splideElem.querySelector('.mm-splide-progress-bar');
		let splide = new Splide(splideElem, {
			type: 'slide',
			arrows: false,
			pagination: false,
			gap: 8,
			perPage: 1,
			padding: { right: 30 },
		}).mount();

		splideElem.classList.add('splide-initialized');

		if (bar) {
			splide.on('mounted move', function () {
				let end = splide.Components.Controller.getEnd() + 1;
				let rate = Math.min((splide.index + 1) / end, 1);
				bar.style.width = String(100 * rate) + '%';
			});

			let totalSlides = splide.length;
			let initialRate = 1 / totalSlides;
			bar.style.width = String(100 * initialRate) + '%';
		}
	}
}

if (window.innerWidth <= 990) {
	document.addEventListener('DOMContentLoaded', function () {
		initMobileSplide();
	});
}
